import { IAppState } from '../../common/state';

export function getUser(state: IAppState) {
  return state.user;
}
